// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_eq-0";
export var actionModalContentContainer = "_eq-1";
export var createTagButton = "_eq-2";
export var footerContainer = "_eq-7";
export var fullWidthDivider = "_eq-3";
export var hasCreateTagButton = "_eq-4";
export var noCreateTagButton = "_eq-5";
export var tagsContainer = "_eq-6";
export var tagsModalContentContainer = "_eq-8";